import { AxiosResponse } from 'axios'

import { axios } from 'services/axios'
import { routes } from 'services/routes'

import type {
  FetchConversationsResponse,
  FetchConversationResponse,
  UpdateConversationResponse,
  DeleteConversationResponse,
  CreateConversationResponse,
  FetchConversationsArguments,
  CreateConversationArguments,
  FetchConversationArguments,
  UpdateConversationArguments,
  DeleteConversationArguments,
} from './types'

export const createConversation = async ({
  agentMode,
  attachmentIds,
  content,
  contentCountry,
  documentReferences,
  language,
  researchMode,
  streamingMode,
}: CreateConversationArguments) => {
  const response = await axios.post<CreateConversationResponse>(
    routes.conversationPath(),
    {
      agentMode,
      attachmentIds,
      content,
      contentCountry,
      language,
      documentReferences,
      researchMode,
      streamingMode,
    },
  )

  if (!response) {
    throw new Error('Couldn\'t create conversation')
  }

  return response.data.conversation
}

export const fetchConversations = async ({
  page,
  limit,
  query,
}: FetchConversationsArguments) => {
  let response: AxiosResponse<FetchConversationsResponse>

  if (query) {
    response = await axios.post<FetchConversationsResponse>(
      routes.conversationsSearchPath({ page, limit }),
      { query },
    )
  }
  else {
    response = await axios.get<FetchConversationsResponse>(
      routes.conversationsListPath({ page, limit }),
    )
  }

  if (!response) {
    throw new Error('Couldn\'t fetch conversations')
  }
  return response.data
}

export const fetchConversation = async ({ id }: FetchConversationArguments) => {
  const response = await axios.get<FetchConversationResponse>(
    routes.conversationPath(id),
  )
  if (!response) {
    throw new Error('Couldn\'t fetch conversation')
  }
  return response.data
}

export const updateConversation = async ({
  id,
  subject,
  pinned,
}: UpdateConversationArguments) => {
  const response = await axios.put<UpdateConversationResponse>(
    routes.conversationPath(id),
    {
      conversation: {
        pinned,
        subject,
      },
    },
  )
  if (!response) {
    throw new Error('Couldn\'t update conversation')
  }
  return response.data
}

export const deleteConversation = async ({ id }: DeleteConversationArguments) => {
  const response = await axios.delete<DeleteConversationResponse>(
    routes.conversationPath(id),
  )
  if (!response) {
    throw new Error('Couldn\'t delete conversation')
  }
  return response.data
}
